// extracted by mini-css-extract-plugin
module.exports = {"sliderHeader":"style_sliderHeader__1OOmv"};